<template>
    <el-container style="height: 100vh;">
        <!-- 侧边栏（PC 端显示，移动端隐藏） -->
        <el-aside width="200px" v-if="!isMobile" style="background: #f5f5f5;">
            <el-menu default-active="1">
                <el-menu-item index="1">菜单1</el-menu-item>
                <el-menu-item index="2">菜单2</el-menu-item>
            </el-menu>
        </el-aside>

        <!-- 移动端顶部导航栏 + 按钮 -->
        <el-header v-if="isMobile" style="display: flex; align-items: center; background: #f5f5f5;">
            <el-button @click="drawer = true" icon="el-icon-more" circle></el-button>
            <span style="margin-left: 10px; font-size: 18px;">智价云</span>
        </el-header>

        <!-- 移动端抽屉式菜单 -->
        <el-drawer title="智价云" :visible.sync="drawer" direction="ltr" size="45%">
            <el-menu default-active="1">
                <el-menu-item index="1">菜单1</el-menu-item>
                <el-menu-item index="2">菜单2</el-menu-item>
            </el-menu>
        </el-drawer>

        <!-- 主内容 -->
        <el-main>

            <h2>这里是主内容</h2>
            <p>无论是 PC 端还是移动端，主内容都不会受影响</p>
        
        </el-main>
  </el-container>
</template>

<script>
import { Container,Header,Aside,Main,Footer,Menu,MenuItem,Drawer,Button} from 'element-ui';
export default {
    components:{
        ElContainer:Container,
        ElHeader:Header,
        ElAside:Aside,
        ElMain:Main,
        ElFooter:Footer,
        ElMenu:Menu,
        ElMenuItem:MenuItem,
        ElDrawer:Drawer,
        ElButton:Button
    },
    data(){
        return{
            drawer: false, // 控制抽屉显示
            isMobile: window.innerWidth < 768, // 判断是否为移动端
        }
    },
    mounted(){
        window.addEventListener("resize", this.updateSize);
        document.title = this.$route.meta.title || "智价云丨 AI";
        this.changeFavicon(require('@/assets/智价云 logo.jpg'));
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateSize);
    },
    methods:{
        updateSize() {
            this.isMobile = window.innerWidth < 768;
        },
        // 修改图标
        changeFavicon(url) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.head.appendChild(link);
            }
            link.href = url;
        }
    }
}
</script>

<style lang="less" scoped>

.deepseekapp{
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid red;
}
</style>